import { BASIC_ROOT_ROUTE } from 'Core/constants'

export const Routes = {
	ROOT: BASIC_ROOT_ROUTE
}
